import { LOCALES, SAVIOR_ATTRIBUTE, SAVIOR_CLASS } from "../constants";

const MULTIPLY_STAT_LIST = ["atk", "hp", "def", "spd"];

const SKILL_INDEX_MATCHER = {
    special_skill_available: 2,
    hyper_skill_available: 3,
};

export const getMajorCategoryList = (battleContents, lang) => {
    return Object.keys(battleContents).map((key, index) => ({
        name: battleContents[key].name[lang],
        type: battleContents[key].type,
        value: index,
    }));
};

export const getMiddleCategoryList = (battleContents, major, lang) => {
    return battleContents[major.type].contents_list.map((contents, index) => ({
        name: major.type === "OPERATION" ? `[${contents.type}] ${contents.name[lang]}` : contents.name[lang],
        value: index,
    }));
};

export const getSubCategoryList = (battleContents, major, middle, lang) => {
    return battleContents[major.type].contents_list[middle.value].battles.map((battle, index) => ({
        name: major.type === "RANKING_RAID" ? battle.step : battle.name[lang],
        battlePower: battle.battle_power,
        difficulty: battle.difficulty,
        step: battle.step,
        level: battle.level,
        buffs: battle.buffs,
        value: index,
    }));
};

export const getWaveList = (battleContents, major, middle, sub, waveSuffix) => {
    return battleContents[major.type].contents_list[middle.value].battles[sub.value].waves.map((wave, index) => ({
        name: `${index + 1} ${waveSuffix}`,
        value: index,
    }));
};

export const getMonsterList = (battleContents, monsters, major, middle, sub, wave, lang) => {
    return battleContents[major.type].contents_list[middle.value].battles[sub.value].waves[wave.value].map((_monster, index) => {
        const monster = monsters.find((e) => e.str_id === _monster.unit_str_id);

        const monsterObj = {
            name: `${monster.name[lang]}`,
            img: monster.img,
            value: index,
            attr: _monster.type || monster.attr,
            class: monster.class,
            level: sub.level,
            isBoss: _monster.is_boss || monster.is_boss || false,
            immuneList: monster.immune_list,
            // 캐시된 monsters.json의 base_stat 원본을 변형하지 않도록 얕은 복제 후 스테이지 보정치 적용
            stats: { ...monster.base_stat },
        };

        monsterObj.stats.atk += (sub.level - 1) * monster.stat_per_level.atk;
        monsterObj.stats.hp += (sub.level - 1) * monster.stat_per_level.hp;
        monsterObj.stats.def += (sub.level - 1) * monster.stat_per_level.def;

        (_monster.stats || []).forEach((stat) => {
            if (stat.is_percent && MULTIPLY_STAT_LIST.includes(stat.type)) {
                monsterObj.stats[stat.type] = Math.floor(monsterObj.stats[stat.type] + (monsterObj.stats[stat.type] * stat.value) / 10_000);
            } else if (stat.is_percent) {
                monsterObj.stats[stat.type] = monsterObj.stats[stat.type] + stat.value;
            } else {
                monsterObj.stats[stat.type] = Math.floor(monsterObj.stats[stat.type] + stat.value);
            }
        });

        // let disableList = Object.keys(_monster).filter((key) => key.endsWith("skill_available") && _monster[key] === false);

        // if (disableList.length > 0) {
        //     console.log(disableList);
        //     disableList = disableList.map((key) => SKILL_INDEX_MATCHER[key]);
        //     monsterObj.skills = monster.skills.filter((skill) => !disableList.includes(skill.type)).sort((a, b) => a.type - b.type);
        // } else {
        monsterObj.skills = monster.skills.slice().sort((a, b) => a.type - b.type);
        // }

        return monsterObj;
    });
};

export const getBuffStatLabel = (lang, buffs, statType) => {
    const found = buffs?.find((buff) => buff.str_id === `BI_STAT_${statType}`);
    if (!found) return statType;

    const name = found.name[lang];
    if (lang === LOCALES.KO) return name.replace(/\s*스탯$/, "");
    if (lang === LOCALES.EN) return name.replace(/^Stat:\s*/, "");
    return name;
};

export const getBuffTargetLabel = (lang, target) => {
    if (!target) return "";
    if (target.type === "attr") {
        const key = `NUAT_${String(target.value).toUpperCase()}`;
        return SAVIOR_ATTRIBUTE[key]?.[lang] ?? target.value;
    }
    if (target.type === "class") {
        const key = `NURT_${String(target.value).toUpperCase()}`;
        return SAVIOR_CLASS[key]?.[lang] ?? target.value;
    }
    return target.value;
};
